'use strict';
import gsap from 'gsap';
import Tab from './Tab';
import Slide from './Slide';
import PosSlide from './PosSlide';
import Sticky from './Sticky';
import { ScrollEffect } from './ScrollEffect.js';

// import Swiper, {Autoplay} from 'swiper/bundle';
// import 'swiper/css';

class Module {
	constructor(){

		new Content();
		new Toggle();
		new CourseChapter();
		new FooterToggle();
		new InlineModal();

		//js-sticky（高さが画面に収まるときだけ追従。はみ出すときは通常フローに戻す）
		document.querySelectorAll('.js-sticky').forEach((el)=>{
			el.sticky = new Sticky(el);
			el.sticky.render();
		});

		//ローカルナビ（SPであふれたら現在地を中央に寄せた状態から始める）
		document.querySelectorAll('.m_localnav').forEach((el)=>{
			this.localNav(el);
		});

		//js-jumpSelect（選んだ option の value のURLへ飛ぶ。活用事例詳細のサイドの絞り込み）
		document.querySelectorAll('.js-jumpSelect').forEach((el)=>{
			el.addEventListener('change', ()=>{
				if( el.value ) location.href = el.value;
			});
		});

		//ぱんクズ（SPであふれたら右端＝現在地が見えた状態から始める）
		document.querySelectorAll('.m_breadcrumbs').forEach((el)=>{
			this.breadcrumbs(el);
		});

		//横にあふれる面（SPの図版など）。あふれている間だけスクロールバーを出す
		document.querySelectorAll('.js-hscroll').forEach((el)=>{
			this.hscroll(el);
		});

		//CVの電話番号（数字の字幅をそろえて、SPで縦に並べたとき端をそろえる）
		document.querySelectorAll('.m_cv_telNum').forEach((el)=>{
			this.telFigures(el);
		});

		// // DOMContentLoadedで囲む
		// document.addEventListener('DOMContentLoaded', () => {
		// 	const arwBg = document.querySelector('.js_arwbg_odj');
		// 	const target = document.querySelector('.js_arwbg');
		// 	if (!target) {
		// 		return;
		// 	}
		// 	const arwBgObserver = new IntersectionObserver((entries) => {
		// 			entries.forEach((entry) => {
		// 					if (entry.isIntersecting) {
		// 							arwBg.classList.add('is-hidden');
		// 					} else {
		// 							if (entry.boundingClientRect.top > 0) {
		// 									arwBg.classList.remove('is-hidden');
		// 							}
		// 					}
		// 			});
		// 	});
		// 	arwBgObserver.observe(target);
		// });


		document.querySelectorAll('.js_slide').forEach((el, i)=>{
			el.slide = new Slide(el);
		});

		document.querySelectorAll('.js_posslide').forEach((el, i)=>{
			el.slide = new PosSlide(el);
		});




		// let isModal = false;
		// $('.js_modal_open').on('click', function(e) {
		// 		e.preventDefault(); // ページトップ移動を防ぐ
		// }).modaal({
		// 		fullscreen: true,
		// 		before_open: function() {
		// 				$('html').addClass('is-modal-open');
		// 				$('.js_modal_close').off('click.modal').on('click.modal', function() {
		// 						$('.js_modal_open').modaal('close');
		// 						isModal = false;
		// 				});
		// 		},
		// 		after_open: function() {
		// 				$('.modaal-wrapper').on('click.modaal_overlay', function(e) {
		// 						if (!$(e.target).closest('.js_modal_content').length) {
		// 								$('.js_modal_open').modaal('close');
		// 						}
		// 				});
		// 		},
		// 		after_close: function() {
		// 				$('html').removeClass('is-modal-open');
		// 				isModal = false;
		// 				$('.modaal-wrapper').off('click.modaal_overlay');
		// 		}
		// });




		// 複数の要素に適用
		const elements = document.querySelectorAll('.scrollEffect');
		elements.forEach(el => ScrollEffect(el));


		// Parallax
		const target = document.querySelector('.top_recruit');
		if (target) {
			const parallax = new Parallax(target);
			parallax.enter();
		}

		//tab
		document.querySelectorAll('.ui-tab').forEach((el, i)=>{
			el.tab = new Tab(el);
		});


		//urlHash
		this.urlHash();

	}


	/**
	 * ページ内アンカー（/service/#solution など）。
	 *   読み込み時 … URLにハッシュが付いていたらその位置へ送る
	 *   クリック時 … いま開いているページ内を指すリンクを拾う。
	 *                href が "#solution" でも "/service/#solution" でも効く
	 *                （フッターの同じリンクを /service/ で押したときなど）
	 *
	 * 止める位置はヘッダーのぶん下げる。PC 7rem（帯5rem + 余白2rem）/ SP 6rem。
	 *
	 * 以前は「位置がずれるので」読み込み時に2秒待ってから送っていたが、
	 * 遷移してから動き出すまでが遅かったので、待たずに送って
	 * 画像・フォントを読み終わってから位置を合わせ直す形にしている。
	 * 合わせ直しは、その間にユーザーが自分で動かしていたら行わない
	 */
	urlHash(){
		const headerGap = ()=> ( 1023 <= app.Util.ww() )? app.Util.fontsize()*8 : app.Util.fontsize()*6;

		// #1 のように CSS セレクタとして不正なハッシュだと querySelector が例外を投げる。
		// ここはコンストラクタから呼ぶので、落とすと new Module() ごと止まり、
		// App.render() のこれ以降（Top / Information / GetEntries）が動かなくなる
		const find = (hash)=>{
			if( !hash || hash === '#' ) return null;
			try { return document.querySelector(hash); } catch(e) { return null; }
		};

		const scrollTo = (target, duration)=>{
			let pos = app.Util.offset(target).top - headerGap();
			if( pos < 0 ) pos = 0;
			if( !duration ) { window.scrollTo(0, pos); return; }
			const scrollObj = { y: window.pageYOffset };
			gsap.to(scrollObj, {
				duration: duration,
				y: pos,
				ease: app.Config.ease.tween,
				overwrite: true, // 連打しても前のトゥイーンと引っ張り合わない
				onUpdate: () => window.scrollTo(0, scrollObj.y)
			});
		};

		// ---- 読み込み時 ----
		const target = find(location.hash);
		if( target ) {
			scrollTo(target, 0.5);

			// 読み終わったら位置を合わせ直す。ユーザーが動かしていたら何もしない
			let moved = false;
			const onUser = ()=>{ moved = true; };
			['wheel', 'touchstart', 'keydown'].forEach((ev)=>{
				window.addEventListener(ev, onUser, { passive: true, once: true });
			});
			const adjust = ()=>{
				if( moved ) return;
				scrollTo(target, 0);
			};
			if( document.fonts && document.fonts.ready ) document.fonts.ready.then(adjust);
			if( document.readyState === 'complete' ) adjust();
			else window.addEventListener('load', adjust, { once: true });
		}

		// ---- 同じページ内のリンク ----
		document.addEventListener('click', (e)=>{
			if( !(e.target instanceof Element) ) return;
			const a = e.target.closest('a[href*="#"]');
			if( !a || a.target === '_blank' ) return;
			// 自前の処理を持っているものには手を出さない。要素に直付けされた
			// ハンドラはこの委譲より先に走るので、そこで止めていれば来ない
			//   .js_loginModal（#logincontents をモーダルで開く / Header.js）
			//   .ss・.wp-block-anchorlink__list a（SmoothScroll.js）
			if( e.defaultPrevented ) return;

			// 別ページ・別ドメインへのリンクは普通に遷移させる。
			// <a> は host / pathname / hash を解決済みで持っているので、
			// URL を組み立て直さない（new URL は core-js の URL ポリフィルを引き込んで
			// バンドルが19KBほど増える）
			if( a.host !== location.host || a.pathname !== location.pathname ) return;

			const el = find(a.hash);
			if( !el ) return;

			e.preventDefault();
			// 遷移しなくなるぶん、SPのドロワーは自分で閉じる。
			// 開いたままだと後ろでスクロールするだけになる
			if( app.Header && app.Header.isOPEN ) app.Header.close();
			history.pushState(null, '', a.hash); // 戻るで戻れるように
			scrollTo(el, 0.5);
		});
	}


	/**
	 * ぱんクズ
	 *  SPは1行で、入りきらないときだけ横スクロールになる。
	 *  そのままだと左端（Home）から始まって現在地が見えないので、
	 *  右端まで送った状態で見せる。短くてあふれないときは何もしない（＝左寄せのまま）。
	 */
	breadcrumbs(el){
		const toEnd = ()=>{
			// PCは絶対配置で流れており、スクロールしない
			if( el.scrollWidth <= el.clientWidth ) return;
			el.scrollLeft = el.scrollWidth;
		};
		toEnd();
		// フォント読み込みで幅が変わるので読み終わってからもう一度
		if( document.fonts && document.fonts.ready ) document.fonts.ready.then(toEnd);
		// PC/SPの切り替えで条件が変わる
		app.Util.layoutChange(toEnd);
	}

	/**
	 * .js-hscroll
	 *  横にあふれる面に、あふれている間だけスクロールバーを出す。
	 *  素の overflow-x:auto は、SPだとスクロールバーが常時出ないため
	 *  「まだ右に続いている」ことが伝わらない。
	 *
	 *  スクロールそのものはブラウザに任せる。指を離したあとの慣性は
	 *  ブラウザ本来のものがいちばんなめらかで、JSで置き換えると必ず粗くなる。
	 *  そのぶんバーは自前で描くが、面の「中」に置くと横スクロールで
	 *  一緒に流れてしまうので、面の直後（外）に作って位置だけ同期させる。
	 *  見た目は _module.scss の .m_hscroll。
	 */
	hscroll(el){
		const bar = document.createElement('div');
		bar.className = 'm_hscroll is-hidden';
		bar.setAttribute('aria-hidden', 'true');
		const thumb = document.createElement('span');
		thumb.className = 'm_hscroll_thumb';
		bar.appendChild(thumb);
		el.after(bar);

		// つまみを今のスクロール位置へ置く
		const move = ()=>{
			const max = el.scrollWidth - el.clientWidth;
			const travel = bar.clientWidth - thumb.offsetWidth;
			if( max <= 0 || travel <= 0 ) return;
			// translate なので描画だけで済む（left だとレイアウトが走る）
			thumb.style.transform = `translateX(${el.scrollLeft / max * travel}px)`;
		};
		// あふれているかを見て、バーの有無とつまみの幅を決める
		const layout = ()=>{
			// 端数で1pxだけ出ることがあるので、その分は無視する
			const overflow = el.scrollWidth > el.clientWidth + 1;
			bar.classList.toggle('is-hidden', !overflow);
			if( !overflow ) return;
			thumb.style.width = `${el.clientWidth / el.scrollWidth * 100}%`;
			move();
		};

		// lenis は smoothWheel:true で wheel を preventDefault し、縦スクロールを
		// 自前の補間に回している。data-lenis-prevent-wheel で面ごと手を引かせると、
		// 縦に転がしたときもページが素のスクロールに変わってひっかかって見える。
		// そこで「横向きの操作」だけこちらで受け取り、lenis まで伝わらないようにする。
		// preventDefault はしないので、横スクロールはブラウザが素のまま動かす。
		// 縦向きと、端まで来たあとは、そのまま lenis に渡す
		el.addEventListener('wheel', (e)=>{
			if( el.scrollWidth <= el.clientWidth + 1 ) return;
			if( Math.abs(e.deltaX) <= Math.abs(e.deltaY) ) return;
			const max = el.scrollWidth - el.clientWidth;
			if( (e.deltaX < 0 && el.scrollLeft <= 0) || (e.deltaX > 0 && el.scrollLeft >= max) ) return;
			e.stopPropagation();
		}, { passive: true });

		// スクロールは毎フレーム飛んでくるので、描き換えは次の描画にまとめる
		let ticking = false;
		el.on('scroll', ()=>{
			if( ticking ) return;
			ticking = true;
			requestAnimationFrame(()=>{ move(); ticking = false; });
		});

		// つまみをつまんで動かす
		thumb.addEventListener('pointerdown', (e)=>{
			const max = el.scrollWidth - el.clientWidth;
			const travel = bar.clientWidth - thumb.offsetWidth;
			if( max <= 0 || travel <= 0 ) return;
			e.preventDefault();
			const startX = e.clientX;
			const startScroll = el.scrollLeft;
			bar.classList.add('is-dragging');
			thumb.setPointerCapture(e.pointerId);
			const onMove = (ev)=>{
				el.scrollLeft = startScroll + (ev.clientX - startX) / travel * max;
			};
			const onUp = ()=>{
				bar.classList.remove('is-dragging');
				thumb.removeEventListener('pointermove', onMove);
				thumb.removeEventListener('pointerup', onUp);
				thumb.removeEventListener('pointercancel', onUp);
			};
			thumb.addEventListener('pointermove', onMove);
			thumb.addEventListener('pointerup', onUp);
			thumb.addEventListener('pointercancel', onUp);
		});

		// 溝を押したらその位置へ送る
		bar.addEventListener('pointerdown', (e)=>{
			if( e.target === thumb ) return;
			const max = el.scrollWidth - el.clientWidth;
			const travel = bar.clientWidth - thumb.offsetWidth;
			if( max <= 0 || travel <= 0 ) return;
			const x = e.clientX - bar.getBoundingClientRect().left - thumb.offsetWidth / 2;
			const to = Math.min(Math.max(x, 0), travel) / travel * max;
			// behavior:'smooth' は iOS 15.4 より前が未対応。使えないときは即移動にする
			if( 'scrollBehavior' in document.documentElement.style ) {
				el.scrollTo({ left: to, behavior: 'smooth' });
			} else {
				el.scrollLeft = to;
			}
		});

		layout();
		// フォントと画像で幅が変わるので、確定してからもう一度測る
		if( document.fonts && document.fonts.ready ) document.fonts.ready.then(layout);
		el.querySelectorAll('img').forEach((img)=>{
			if( !img.complete ) img.on('load', layout);
		});
		app.Util.resize(layout, '.hscroll');
	}

	/**
	 * .m_cv_telNum
	 *  Poppins は数字の字幅がそろっておらず（1 が細い）、そろえるための
	 *  tnum も持っていない。そのままだと東京と大阪で番号の見た目の長さが変わり、
	 *  SPで縦に並べたときに左右の端がずれる。
	 *  数字を1文字ずつ同じ幅の箱に入れて、桁の位置をそろえる。
	 *  箱の幅は _module.scss の .m_cv_telFig 側にある（PCでは箱にしない）
	 */
	telFigures(el){
		const target = el.querySelector('.t_en') || el;
		if( target.querySelector('.m_cv_telFig') ) return;
		const frag = document.createDocumentFragment();
		for( const char of target.textContent ) {
			if( char < '0' || char > '9' ) {
				frag.appendChild(document.createTextNode(char));
				continue;
			}
			const box = document.createElement('span');
			box.className = 'm_cv_telFig';
			box.textContent = char;
			frag.appendChild(box);
		}
		target.textContent = '';
		target.appendChild(frag);
	}

	localNav(el){
		const current = el.querySelector('.m_localnav_item.is-current');
		if( !current ) return;
		const toCurrent = ()=>{
			// PCは横スクロールしない
			if( el.scrollWidth <= el.clientWidth ) return;
			const navRect = el.getBoundingClientRect();
			const itemRect = current.getBoundingClientRect();
			// 端の項目で行き過ぎる分はブラウザが丸める
			el.scrollLeft += (itemRect.left + itemRect.width / 2) - (navRect.left + navRect.width / 2);
		};
		toCurrent();
		// フォント読み込みで幅が変わるので読み終わってからもう一度
		if( document.fonts && document.fonts.ready ) document.fonts.ready.then(toCurrent);
		// PC/SPの切り替えで条件が変わる
		app.Util.layoutChange(toCurrent);
	}
}

class Toggle {
	constructor(){
		this.render();
	}
	render(){
		const els = document.querySelectorAll('.js-toggle');
		if ( els.length === 0 ) return;
		const setHeight = (el)=>{
			const body = el.querySelector('.js-toggle__body');
			const height = el.querySelector('.js-toggle__inner').offsetHeight;
			body.style.setProperty('--height', `${height}px`);
		};
		els.forEach((el)=>{
			setHeight(el);
			app.Util.resize(()=>{
				setHeight(el);
			});
			const head = el.querySelector('.js-toggle__head');
			head.addEventListener('click', (e)=>{
					e.preventDefault(); // 遷移を止める
					setHeight(el);
					el.classList.toggle('is-open');
			});
		});
	}
}

// 講座詳細のカリキュラム（アコーディオン）
//
// 269記事の本文HTMLは編集しないので、旧サイトの作法をそのまま引き継ぐ。
//   <div class="mct_d_ttl navi-more-icon">見出し</div>
//   <div class="mct_d_pf cf" style="display:none;">中身</div>
// 開いている状態を表すクラスは旧サイトと同じ .toPlus（＋ → − に変わる）で、
// 見た目は _object/_project/_course.scss の .crs_legacy.content .mct_d_ttl 側にある。
//
// 旧サイトはこの処理を /js/share.js に持っていたが、新テンプレートは
// share.js を読み込んでいないので開かなくなっていた。ここで実装し直している。
// .js-toggle（--height を使う共通のトグル）に寄せられないのは、
// 中身に style="display:none" が直接書かれていて高さが測れないため。
class CourseChapter {
	constructor(){
		this.render();
	}
	render(){
		const els = document.querySelectorAll('.crs_legacy .mct_d_ttl.navi-more-icon');
		if ( els.length === 0 ) return;
		els.forEach((el)=>{
			const body = el.nextElementSibling;
			if ( ! body || ! body.classList.contains('mct_d_pf') ) return;
			el.setAttribute('role', 'button');
			el.setAttribute('tabindex', '0');
			el.setAttribute('aria-expanded', 'false');
			const card = el.closest('.mct_d');
			const toggle = ()=>{
				const isOpen = el.classList.toggle('toPlus');
				el.setAttribute('aria-expanded', String(isOpen));
				// カードの下あきは開閉で基準の行が変わる（_course.scss の .mct_d.is-open）
				if ( card ) card.classList.toggle('is-open', isOpen);
				$(body).stop(true, true).slideToggle(300);
			};
			el.addEventListener('click', toggle);
			el.addEventListener('keydown', (e)=>{
				if ( e.key === 'Enter' || e.key === ' ' ) {
					e.preventDefault();
					toggle();
				}
			});
		});
	}
}

class FooterToggle {
	constructor(){
		this.render();
	}
	render(){
		const els = document.querySelectorAll('.js-ac');
		if ( els.length === 0 ) return;
		const setHeight = (el)=>{
			const body = el.querySelector('.js-ac__body');
			const height = el.querySelector('.js-ac__inner').offsetHeight;
			body.style.setProperty('--height', `${height}px`);
		};
		els.forEach((el)=>{
			// 中身の欠けた項目は飛ばす（1つの例外で後続の初期化まで止まるため）
			if ( !el.querySelector('.js-ac__head') || !el.querySelector('.js-ac__body') || !el.querySelector('.js-ac__inner') ) return;
			setHeight(el);
			app.Util.resize(()=>{
				setHeight(el);
			});
			const head = el.querySelector('.js-ac__head');
			head.addEventListener('click', (e)=>{
					// SP時だけリンクを無効化
					if (window.matchMedia('(max-width: 1023px)').matches) {
						e.preventDefault(); // 遷移を止める

						setHeight(el);
						el.classList.toggle('is-open');
					}
			});
		});
	}
}


class InlineModal {
	/**
	 * 旧HTMLの隠しモーダル（.mfp-hide）をモーダルで開く。
	 *  講座詳細の Cegos プラン表（28記事）で使っている。
	 *  「詳しくはこちら」の <a href="#cegos-popular"> を押すと、
	 *  同じidの <div id="cegos-popular" class="mfp-hide"> が中身として開く。
	 *
	 *  旧サイトは magnific-popup で開いていたが、このサイトは magnific-popup を
	 *  積んでいないので、ヘッダーのログインモーダル（Header.js の login()）と同じく
	 *  modaal に寄せる。.mfp-hide の display:none は _course.scss 側で当てている。
	 */
	constructor(){
		this.render();
	}
	render(){
		const targets = document.querySelectorAll('.mfp-hide[id]');
		if( targets.length === 0 ) return;

		targets.forEach((target)=>{
			// ヘッダーのログイン（#logincontents）は Header.js が持っているので触らない
			if( target.id === 'logincontents' ) return;

			const $trigger = $(`a[href="#${target.id}"]`);
			if( !$trigger.length ) return;
			// モーダルの中で押された同ページ内リンク。閉じ終わってから飛ぶ
			let pendingHash = '';

			$trigger.on('click', (e)=>{
				e.preventDefault(); // ページ内リンクとして飛ぶのを止める
			}).modaal({
				type: 'inline',
				animation: 'fade',
				custom_class: 'modaal-inlineContent', // 見た目はこのクラス配下だけに閉じる
				background: 'rgba(21, 39, 84, 0.2)',
				overlay_opacity: 1,
				before_open: ()=>{
					app.html.classList.add('is-modal-open');
					// 背面のスクロールを止める。lenis を使っているので body の
					// overflow だけでは効かない
					if( app.lenis ) app.lenis.stop();
				},
				after_open: ($wrapper)=>{
					// lenis は停止中も wheel / touch を preventDefault するので、
					// このままだとモーダルの中もスクロールできない。
					// data-lenis-prevent が付いた要素の中では lenis が手を引く
					$wrapper.attr('data-lenis-prevent', '');
					// 中の同じページ内リンク（/course-tag/cegos/ の「Cegosの講座一覧を見る」#archivelist）は
					// モーダルを閉じ終わってから飛ばす。閉じるときに modaal がフォーカスを
					// 「詳しくはこちら」へ戻し、先にスクロールしてもボタンの位置へ引き戻されるため
					$wrapper.off('click.inlineModal').on('click.inlineModal', 'a[href^="#"]', (e)=>{
						e.preventDefault();
						e.stopPropagation();
						pendingHash = e.currentTarget.getAttribute('href');
						$trigger.modaal('close');
					});
				},
				after_close: ()=>{
					app.html.classList.remove('is-modal-open');
					if( app.lenis ) app.lenis.start();
					if( !pendingHash ) return;
					// スクロールはヘッダーの高さを引く同ページリンクの処理（Module）に任せる
					const a = document.createElement('a');
					a.href = pendingHash;
					pendingHash = '';
					document.body.appendChild(a);
					a.click();
					a.remove();
				}
			});
		});
	}
}


class Parallax {
  constructor(el){
    this.wrap = el;
    this.isWatch = false;
    this._onScroll = () => this.scroll();

    this.observer = new IntersectionObserver((entries)=>{
      entries.forEach((entry)=>{
        this.isWatch = entry.isIntersecting;
        this.scroll();
      });
    });
  }

  enter(){
    this.observer.observe(this.wrap);
    window.addEventListener('scroll', this._onScroll);
  }

  scroll(){
    if( !this.isWatch ) return;
    let y = Math.round(app.Util.sy() - app.Util.offset(this.wrap).top + app.Util.wh());
    if( y < 0 ) {
      y = 0;
    }
    this.wrap.style.setProperty('--scroll', y);
  }
}


class Content {
	constructor(){
		// this.$easingFade = $('.js-easing-fade');
		// this.$easingBlur = $('.js-easing-blur');
		this.lower = document.querySelector('.lower-page');
		this.splitPagettl();
		this.render();
	}
	// ページタイトルを1文字ずつ span に割る。CSS 側の .c_splitChar が
	// --i を遅延に使って左からスライドさせる。
	// .is-show が付く前に走らせること（初期状態を効かせるため）。
	// 対象は c_pagettl（下層ページのタイトル）と service_fv（サービス一覧のFV）。
	// 和文・英字を DOM 順に通し番号で振るので、上から順に流れる。
	//  - 和文… 英数字の連続は1かたまり。AI / DX が語の途中で折れないように
	//  - 英字… 1文字ずつ。ただし語を .c_splitWord でくくって折り返しを防ぐ
	// <br> と .c_pagettl_icon は触らない
	splitPagettl(){
		if( !this.lower ) return;
		// 見出しの箱。DOM 順で拾うので、和文が先／英字が先のどちらの並びでも上から流れる
		const boxes = this.lower.querySelectorAll('.c_pagettl_jp, .c_pagettl_en, .service_fv_label, .service_fv_en');
		if( !boxes.length ) return;
		// 英字（1文字ずつ・語は .c_splitWord でくくる）側の見分け
		const EN = '.c_pagettl_en, .service_fv_en';
		let i = 0;

		const charSpan = (text)=>{
			const span = document.createElement('span');
			span.className = 'c_splitChar';
			span.style.setProperty('--i', i++);
			span.textContent = text;
			return span;
		};

		// 和文：英数字の連続だけ1かたまりにまとめる
		const fillJp = (frag, text)=>{
			const units = [];
			Array.from(text).forEach((c)=>{
				const last = units[units.length - 1];
				if( /[0-9A-Za-z]/.test(c) && last && /^[0-9A-Za-z]+$/.test(last) ) {
					units[units.length - 1] = last + c;
				} else {
					units.push(c);
				}
			});
			units.forEach((u)=>{ frag.appendChild(charSpan(u)); });
		};

		// 英字：1文字ずつ。空白以外の連なりは .c_splitWord でくくる
		const fillEn = (frag, text)=>{
			const chunks = text.match(/\s+|\S+/g);
			if( !chunks ) return;
			chunks.forEach((chunk)=>{
				if( /^\s+$/.test(chunk) ) {
					Array.from(chunk).forEach((c)=>{ frag.appendChild(charSpan(c)); });
					return;
				}
				const word = document.createElement('span');
				word.className = 'c_splitWord';
				Array.from(chunk).forEach((c)=>{ word.appendChild(charSpan(c)); });
				frag.appendChild(word);
			});
		};

		boxes.forEach((box)=>{
			// .t_hl は中にあることも（c_pagettl_jp）、箱自身に付いていることも（service_fv_label）ある
			const root = box.querySelector('.t_hl') || box;
			const isEn = box.matches(EN);
			const walk = (node)=>{
				Array.from(node.childNodes).forEach((child)=>{
					if( child.nodeType === Node.TEXT_NODE ) {
						if( !child.textContent ) return;
						const frag = document.createDocumentFragment();
						if( isEn ) { fillEn(frag, child.textContent); } else { fillJp(frag, child.textContent); }
						child.replaceWith(frag);
					} else if( child.nodeType === Node.ELEMENT_NODE && child.tagName !== 'BR' ) {
						walk(child);
					}
				});
			};
			walk(root);
		});
	}
	render(){
		if( this.lower ) {
			gsap.delayedCall(0.2, ()=>{
				this.lower.classList.add('is-show');
			});
		}


		// if( this.$easingFade.length ) {
		// 	TweenMax.delayedCall(0.3, ()=>{
		// 		this.$easingFade.addClass('is-visible');
		// 	});
		// }
		// if( this.$easingBlur.length ) {
		// 	TweenMax.delayedCall(0.1, ()=>{
		// 		this.$easingBlur.addClass('is-visible');
		// 	});
		// }
		// if( this.$easingFade.length ) {
		// 	TweenMax.delayedCall(0.1, ()=>{
		// 		this.$easingFade.addClass('is-visible');
		// 	});
		// }
		// if( this.$easingBlur.length ) {
		// 	TweenMax.delayedCall(0.1, ()=>{
		// 		this.$easingBlur.addClass('is-visible');
		// 	});
		// }
	}
}




export default Module;
